import React from 'react';
import { Project, Organization } from '../../../types/domain';
import { ProjectCard } from '../components/ProjectCard';
import { Button } from '../../../components/ui/Button';
import { Plus, FolderKanban } from 'lucide-react';

interface OrganizationProjectsTabProps {
  projects: Project[];
  currentOrg: Organization | null;
  canManageOrg: boolean;
  onCreateProjectClick: () => void;
}

export const OrganizationProjectsTab: React.FC<OrganizationProjectsTabProps> = ({
  projects,
  currentOrg,
  canManageOrg,
  onCreateProjectClick,
}) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {projects.map((p) => (
          <ProjectCard key={p.id} project={p} orgId={currentOrg?.id} />
        ))}

        {projects.length === 0 && (
          <div className="col-span-full py-16 px-4 text-center rounded-xl bg-cf-surface border border-cf-border">
            <div className="w-10 h-10 rounded-full bg-cf-bg border border-cf-border flex items-center justify-center mx-auto text-cf-textSecondary mb-2">
              <FolderKanban size={20} />
            </div>
            <div className="text-xs font-semibold text-cf-textPrimary uppercase tracking-wider">
              No Projects Found
            </div>
            <p className="text-xs text-cf-textSecondary mt-1 max-w-sm mx-auto">
              Create your first project to organize datastores and notification providers.
            </p>
            {canManageOrg && (
              <div className="mt-4">
                <Button
                  type="button"
                  variant="primary"
                  size="sm"
                  onClick={onCreateProjectClick}
                  icon={<Plus size={14} />}
                >
                  Create Project
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
